import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
import useTableR from "../useTableR";
import axios from "axios";
import { Dimmer } from "../spinner";
import { formatMoneda } from "@/util/varios";
const headCells = [
  {
    id: "1",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "2",
    label: "TIPO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "3",
    label: "DESCRIPCION",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "4",
    label: "VALOR",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
];
export default function ModalClaseTerreno(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [itemSelect, setItemSelect] = useState({
    item: "",
    index: -1,
  });
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const buscarRegistros = () => {
    setLoading(true);
    const campos = "*";
    const tabla = "claseterreno";
    const orden = "idclaseterreno";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${tabla}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          setRecords(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableR(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idclaseterreno.includes(target.value) ||
              x.tipo.toLowerCase().includes(target.value.toLowerCase()) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.valor.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const seleccionarClasificador = () => {
    props.seleccionarClasificador(itemSelect.item);
    salir();
  };
  const blanquear = () => {
    setItemSelect({
      item: "",
      index: -1,
    });
    setLoading(false);
    setRecords([]);
  };
  const salir = () => {
    props.setHidden();
  };
  return (
    <Modal
      {...props}
      size="lg"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onShow={() => {
        blanquear();
        buscarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3
          className=" fw-bold text-light m-0"
          style={{
            fontSize: "1.2rem",
          }}
        >
          Lista de Clases de Terreno
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 p-0">
          <div className="input-group input-group-sm mb-3 m-0 col-md-5">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
              placeholder="Buscar Clase Terreno..."
            />
          </div>
        </div>

        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                records.length > 0 &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    onClick={() =>
                      setItemSelect({
                        item: item,
                        index: index,
                      })
                    }
                    style={{
                      padding: "0",
                      background:
                        itemSelect.index === index ? "lightskyblue" : "white",
                    }}
                  >
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {item.idclaseterreno}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {item.tipo}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "auto" }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {formatMoneda(
                        item.valor.toString().replace(".", ","),
                        ",",
                        ".",
                        2,
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => seleccionarClasificador()}
          className="btn-sm rounded-pill btn btn-info col-md-3"
        >
          <i className="fas fa-check" /> ACEPTAR
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close" /> Salir
        </button>
      </Modal.Footer>
      <Dimmer active={loading} inverted />
    </Modal>
  );
}
